import { getFeedsComments } from '@/pages/opinion/services';
import { useEffect, useState } from 'react';

export function useFeedsCommentItem() {
  const [mainItem, setMainItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [empty, setEmpty] = useState(true);

  function getFeedsContents(params: any) {
    setLoading(true);
    getFeedsComments({
      ...params,
      page_source: 'feeds_detail',
      social_media_by_account: ['99999'],
      social_media_by_keyword: ['99999'],
      external_data_sources: ['99999'],
    })
      .then((data: any) => {
        const dataItem = data?.list?.[0];
        setEmpty(!dataItem);
        setMainItem(dataItem);
      })
      .catch(() => {
        setEmpty(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return {
    mainItem,
    loading,
    getFeedsContents,
    empty,
  };
}

export function useFeedsCommentList({
  gameInfo,
  id,
  endTime,
  feedsSource,
}: any) {
  const [commentList, setCommentList] = useState<Array<any>>([]);
  const [loading, setLoading] = useState(false);
  const [empty, setEmpty] = useState(true);

  function getFeedsContents() {
    setLoading(true);
    const params = {
      ...gameInfo,
      comment_uins: [id],
      need_link_comments: true,
      page_source: 'feeds_detail',
      end_time: endTime,
      social_media_by_account: ['99999'],
      social_media_by_keyword: ['99999'],
      external_data_sources: ['99999'],
    };
    if (feedsSource) {
      params.feed_source = feedsSource;
    }
    getFeedsComments(params)
      .then((data: any) => {
        const dataList = data?.list;
        setEmpty(!dataList || dataList?.length === 0);
        setCommentList(dataList);
      })
      .catch(() => {
        setEmpty(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    if (id) {
      getFeedsContents();
    }
  }, [id]);

  return {
    commentList,
    loading,
    empty,
  };
}
